
  import { Prop, Component, Vue } from 'vue-property-decorator';
  import { OrderModel } from '@/models';

  @Component
  export default class CanceledWithSelfDeliveryAlert extends Vue {
    @Prop() readonly order!: OrderModel;
  }
